// extracted by mini-css-extract-plugin
export var addToCartButton = "_ng-b";
export var arrowButtonContainer = "_ng-9";
export var arrowButtonIcon = "_ng-a";
export var carouselArrowButton = "_ng-6";
export var carouselElementContainer = "_ng-1";
export var left = "_ng-7";
export var productDisplayCarouselContainer = "_ng-0";
export var productTileContainer = "_ng-2";
export var productTileImage = "_ng-4";
export var productTileImageContainer = "_ng-3";
export var productTileTitle = "_ng-5";
export var right = "_ng-8";
export var sliderOverflow = "_ng-c";